import { render, staticRenderFns } from "./MailboxComposeModal.vue?vue&type=template&id=70e697f6&"
import script from "./MailboxComposeModal.vue?vue&type=script&lang=js&"
export * from "./MailboxComposeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70e697f6')) {
      api.createRecord('70e697f6', component.options)
    } else {
      api.reload('70e697f6', component.options)
    }
    module.hot.accept("./MailboxComposeModal.vue?vue&type=template&id=70e697f6&", function () {
      api.rerender('70e697f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/apps/mailbox/MailboxComposeModal.vue"
export default component.exports